/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

export interface RebrandingItemTO {
   attribute: string;
   value: string;
   type: string;
}

export enum IMAGE_ATTRIBUTES {
   horizonLogoImage = "horizonLogoImage"
}

export const REBRAND_IMAGE_MAP: Map<string, string> = new Map<string, string>([
   [IMAGE_ATTRIBUTES.horizonLogoImage, ""]
]);
